import React from 'react';
import moment from 'moment';
import { useLocation } from 'react-router';

import { CG } from 'contexts';
import { RHP } from 'providers';
import * as Styled from './StyledConversation';

export const Conversation = ({ match }) => {
    const { state: global } = React.useContext(CG);
    const location = useLocation();
    const matchId = location.pathname.replace('/100-10-1/messages', '').replace('/', '');

    // Moment language
    let lang = global.language;
    if (global.language === 'pt') {
        lang = 'pt-br';
    }
    moment.locale(lang);

    const momentDate = moment(match.lastMessage?.regDate || match.lastUpdated);
    const formatDate = momentDate.startOf('hour').fromNow();

    const handleClick = () => {
        RHP.push(`/100-10-1/messages/${match.matchid}`);
    };

    return (
        <Styled.Conversation
            className={matchId === match.matchid ? 'active' : ''}
            onClick={handleClick}
        >
            <Styled.ConversationImage img={match.startup.logoUrl}>
                {!!match.unreadMessages && <span className="badge">{match.unreadMessages}</span>}
            </Styled.ConversationImage>

            {match.lastMessage?.messageid !== undefined ? (
                <Styled.ConversationTexts>
                    <span className="startup">{match.startup.name}</span>
                    <Styled.ConversationInfos>
                        <span className="date">{formatDate}</span>
                        <span className="icon fas fa-arrow-right" aria-hidden="true" />
                    </Styled.ConversationInfos>
                </Styled.ConversationTexts>
            ) : (
                <Styled.ConversationTexts>
                    <span className="startup multiline">{match.startup.name}</span>
                </Styled.ConversationTexts>
            )}
        </Styled.Conversation>
    );
};
